import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { uniqBy } from "lodash";
import { useSnackbar } from "notistack";
import * as React from "react";
import { useHistory } from "react-router-dom";
import AdminPageFilterComponent from "../../../components/AdminPageFilterComponent";
import useConstructor from "../../../core/hooks/useConstructor";
import BaseFilter from "../../../core/models/BaseFilter";
import { ordinationModel } from "../../../core/models/BaseModels";
import {
  EVENT_ADMIN_FILTER_TEXT_CHANGE,
  EVENT_ADMIN_FILTER_ORDER_CHANGE,
  EVENT_ADMIN_FILTER_ORGANIZATION_CHANGE,
  EVENT_ADMIN_FILTER_DIRECTORSHIP_CHANGE,
  EVENT_ADMIN_FILTER_EXPIRED_GROUPS_CHANGE,
  EVENT_ADMIN_FILTER_MY_GROUPS,
} from "../../../Events";
import { FETCH_DIRECTORIES, FETCH_ORGANIZATIONS } from "../../../Fedx";
import { useHubx } from "../../../HubX";

function AdminPageFilter() {
  const [searchInput, setSearchInput] = React.useState<string>();
  const [organizations, setOrganizations] = React.useState<string[]>([]);
  const [directories, setDirectories] = React.useState<string[]>([]);
  const [selectedDirectorShip, setSelectedDirectorShip] = React.useState<string>("all");
  const [selectedOrganization, setSelectedOrganization] = React.useState<string>("all");
  const [expiredGroups, setExpiredGroups] = React.useState<boolean>(false);
  const [selectedOrder, setOrder] = React.useState<ordinationModel>("asc");
  const [myGroups, setMyGroups] = React.useState<boolean>(true);

  const hub = useHubx();
  const toastr = useSnackbar();
  const history = useHistory();

  useConstructor(async () => {
    const fetchDirectories = async () => {
      try {
        const APIResponse: string[] = await hub.request(FETCH_DIRECTORIES);

        const useDirectories = uniqBy(APIResponse, (o) => {
          return o?.trimLeft()?.trimRight()?.toLocaleLowerCase();
        });

        setDirectories(useDirectories);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("AdminPageFilter → fetchDirectories → error", error);
        toastr.enqueueSnackbar(
          "Ops! Ocorreu um problema ao tentar obter as opções cadastradas de diretorias!",
          { variant: "error" }
        );
      }
    };

    const fetchOrganizations = async () => {
      try {
        const APIResponse: string[] = await hub.request(FETCH_ORGANIZATIONS);

        const useOrganizations = uniqBy(APIResponse, (o) => {
          return o?.trimLeft()?.trimRight()?.toLocaleLowerCase();
        });

        setOrganizations(useOrganizations);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("AdminPageFilter → fetchDirectories → error", error);
        toastr.enqueueSnackbar(
          "Ops! Ocorreu um problema ao tentar obter as opções cadastradas de organizações!",
          { variant: "error" }
        );
      }
    };

    fetchDirectories();
    fetchOrganizations();
  });

  const handleClickSearch = (e: React.ChangeEvent<{ value: string }>, text?: string) => {
    const newValue = text;
    setSearchInput(newValue);
    hub.notify(EVENT_ADMIN_FILTER_TEXT_CHANGE, newValue);
  };

  const handleChangeOrganization = (e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setSelectedOrganization(newValue);
    hub.notify(EVENT_ADMIN_FILTER_ORGANIZATION_CHANGE, newValue === "all" ? "" : newValue);
  };

  const handleChangeDirectorShip = (e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setSelectedDirectorShip(newValue);
    hub.notify(EVENT_ADMIN_FILTER_DIRECTORSHIP_CHANGE, newValue === "all" ? "" : newValue);
  };

  const handleChangeExpiredGroups = (e: React.ChangeEvent<{ value: boolean }>) => {
    setExpiredGroups(!expiredGroups);
    hub.notify(EVENT_ADMIN_FILTER_EXPIRED_GROUPS_CHANGE, !expiredGroups);
  };

  const handleChangeOrder = (e: React.ChangeEvent<{ value: ordinationModel }>) => {
    const newValue = e.target.value;
    setOrder(newValue);
    hub.notify(EVENT_ADMIN_FILTER_ORDER_CHANGE, newValue);
  };

  const handleChangeMyGroups = (e: React.ChangeEvent<{ value: boolean }>) => {
    setMyGroups(!myGroups);
    hub.notify(EVENT_ADMIN_FILTER_MY_GROUPS, !myGroups);
  };

  const filters: BaseFilter[] = [
    {
      id: "buscar",
      label: "Buscar",
      value: searchInput,
      handleChange: handleClickSearch,
    },
    {
      id: "organizacao",
      items: [
        {
          key: "all",
          value: <strong>Todas</strong>,
        },
        ...organizations.sort().map((x) => {
          return { key: x, value: x };
        }),
      ],
      label: "Organização",
      value: selectedOrganization,
      handleChange: handleChangeOrganization,
    },
    {
      id: "diretoria",
      items: [
        {
          key: "all",
          value: <strong>Todas</strong>,
        },
        ...directories.sort().map((x) => {
          return { key: x, value: x };
        }),
      ],
      label: "Diretoria",
      value: selectedDirectorShip,
      handleChange: handleChangeDirectorShip,
    },
    {
      id: "exp-groups",
      label: "Expiráveis",
      value: expiredGroups,
      handleChange: handleChangeExpiredGroups,
    },
    {
      id: "ordenar",
      items: [
        { key: "asc", value: "A-Z" },
        { key: "desc", value: "Z-A" },
      ],
      label: "",
      value: selectedOrder,
      handleChange: handleChangeOrder,
    },
    {
      id: "meus-grupos",
      label: "Meus Grupos",
      value: myGroups,
      handleChange: handleChangeMyGroups,
    },
  ];

  const handleClickCreateGroup = () => {
    history.push("/admin/new");
  };

  return (
    <AdminPageFilterComponent handleClickCreateGroup={handleClickCreateGroup} filters={filters} />
  );
}

export default AdminPageFilter;
